import React from 'react'
import { connect } from 'react-redux'
import * as WizardClasses from '../WizardClasses'
import { Select } from './Form'

class LocalSelect extends React.Component {
  getRepeaterOptions = () => [
    { value: '', label: '[Select an option]' },
    ...this.props.srcRepeater.value.map(row => ({
      value: row._rowId,
      label: new WizardClasses[this.props.srcField.fieldClass]().getHumanReadableValue(
        this.props.srcField,
        row[this.props.srcField.fieldId]
      )
    }))
  ]
  render() {
    const { value, onChange, onBlur, width, disabled } = this.props
    const options = this.getRepeaterOptions()
    return (
      <Select width={width} value={value} disabled={disabled} options={options} onChange={onChange} onBlur={onBlur} />
    )
  }
}
export default connect((state, props) => {
  const srcRepeater = state.wizard.wizard.fields[props.srcRepeater]
  const srcField = srcRepeater ? state.wizard.wizard.fields[props.srcField] : null
  return {
    srcRepeater,
    srcField,
    fields: state.wizard.wizard.fields
  }
})(LocalSelect)
